import apiClient from '@/api/apiClient.js';
import { getInstProfesId, getClinicalHistoriesId } from '../../utils/storeHelpers';
import { sectionIdFromRoute } from '../../utils/routeSectionMap';
import { handleError, getAuthData } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    anamIndex: {},
    anamGroupShow: {},
    hasPermission: null,
    observerHCP: false,
  },

  getters: {
    anamIndex: (state) => state.anamIndex,
    anamGroupShow: (state) => state.anamGroupShow,
    hasPermission: (state) => state.hasPermission,
    observerHCP: (state) => state.observerHCP,
  },

  mutations: {
    insertAnamIndex(state, payload) {
      state.anamIndex = payload.anamIndex;
      state.anamGroupShow = payload.anamGroupShow;
    },
    SET_PERMISSION(state, hasPermission) {
      state.hasPermission = hasPermission;
    },
    insertObserverHCP(state, observerHCP) {
      state.observerHCP = observerHCP;
    },
    sendSuccess(state) {
      state.status = 'success';
    },
    sendError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadPermissionsHCP({ commit }) {
      try {
        const clinicalHistories_id = getClinicalHistoriesId();
        const institutions_profes_id = getInstProfesId();
        const res = await apiClient.getPermissionsIndexHCP(
          clinicalHistories_id,
          institutions_profes_id,
        );
        const anamIndex = res.data.data;
        const anamGroupShow = anamIndex.anamGroupShow;

        commit('insertAnamIndex', { anamIndex, anamGroupShow });
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async sectionsHCPandRoute({ dispatch }, route) {
      const numSectionHCP = sectionIdFromRoute(route);
      if (numSectionHCP) {
        await dispatch('checkPermission', numSectionHCP);
      }
    },

    async checkPermission({ commit, rootState, dispatch }, numSectionHCP) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.getPermissionsHCP(
          clinicalHistories_id,
          institutions_profes_id,
          numSectionHCP,
        );
        await dispatch('loadObserverHCP', numSectionHCP);
        commit('SET_PERMISSION', Boolean(res?.data?.data?.permission));
      } catch (error) {
        handleError(error, commit, 'SET_PERMISSION', false);
      }
    },

    async loadObserverHCP({ commit }, numSectionHCP) {
      try {
        const clinicalHistories_id = getClinicalHistoriesId();
        const institutions_profes_id = getInstProfesId();
        const res = await apiClient.getObserverHCP(
          clinicalHistories_id,
          institutions_profes_id,
          numSectionHCP,
        );
        const observerHCP = res.data.data;

        commit('insertObserverHCP', observerHCP);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
